import colors from 'styles/colors'
import { typography } from 'styles/typography'

export const defaultStyles = {
  container: {
    boxShadow: '0 3px 6px 0 rgba(0,0,0,0.06)',
    borderRadius: 4,
    backgroundColor: colors.white
  },
  content: {
    padding: '33px 30px',
    marginTop: '-1rem'
  },
  locationsContent: {
    marginTop: '-1rem'
  },
  sectionTitle: {
    marginBottom: 9,
    ...typography.fontSemiBold,
    fontSize: 14,
    lienHeight: '10px',
    color: colors.lightBlack
  },
  contentText: {
    ...typography.font,
    fontSize: 14,
    lineHeight: '19px',
    color: colors.darkStormy
  },
  flexBox: {
    display: 'flex'
  },
  flexBoxBasis: (basis) => ({
    flexBasis: basis
  }),
  contentItem: {
    width: '80%',
    padding: 0,
    listStyleType: 'none',
    ...typography.font,
    fontSize: 14,
    lienHeight: '19px',
    color: colors.darkStormy
  },
  contentItemMb: {
    marginBottom: 20
  },
  practiceLocationsContainer: {
    margin: 0
  },
  location: {
    display: 'flex',
    padding: '24px 17px 21px 20px',
    borderBottom: `1px solid ${colors.unicornSilver}`
  },
  locationInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 11,
    marginTop: -3
  },
  locationName: {
    marginBottom: 10,
    ...typography.fontBold,
    fontSize: 16,
    lineHeight: '16px',
    letterSpacing: 0.23,
    color: colors.darkStormy
  },
  locationAddress: {
    marginBottom: 10,
    ...typography.font,
    fontSize: 16,
    lineHeight: '16px',
    color: colors.darkGray
  },
  locationPhone: {
    cursor: 'pointer',
    ...typography.font,
    fontSize: 16,
    lineHeight: '16px',
    color: colors.primary
  },
  mapErrorText: {
    marginTop: 100,
    textAlign: 'center'
  }
}
